import React from 'react';
import Header from './Header';
import Footer from './Footer';

const Disclaimer: React.FC = () => (
  <div className="page-container">
    <Header />
    <main className="page-content">
      <h1>Disclaimer</h1>
      <p>
        The information provided by Consphic is for general informational purposes only. While we strive for accuracy, we make no warranties regarding the completeness or reliability of any information on this site. Use of our website and services is at your own risk.
      </p>
    </main>
    <Footer />
  </div>
);

export default Disclaimer;
